String.prototype.addQueryStringParameter = function(key, value) {
  const separator = this.indexOf('?') !== -1 ? '&' : '?'
  return this + separator + key + '=' + value
}
